const SESSION_DURATION = 30 * 60 * 1000; // 30 minutes
const SESSION_KEY = 'trustshop_session';
const TRACKED_KEY = 'trustshop_tracked_events';

function getSession(): { id: string; expiresAt: number } | null {
    try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        if (!raw) return null;
        const session = JSON.parse(raw);
        if (Date.now() > session.expiresAt) {
            sessionStorage.removeItem(SESSION_KEY);
            sessionStorage.removeItem(TRACKED_KEY);
            return null;
        }
        return session;
    } catch {
        return null;
    }
}

function ensureSession(): { id: string; expiresAt: number } {
    let session = getSession();
    if (!session) {
        session = {
            id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
            expiresAt: Date.now() + SESSION_DURATION,
        };
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
        sessionStorage.removeItem(TRACKED_KEY);
    }
    return session;
}

function getTrackedEvents(): Set<string> {
    try {
        const raw = sessionStorage.getItem(TRACKED_KEY);
        return raw ? new Set(JSON.parse(raw)) : new Set();
    } catch {
        return new Set();
    }
}

function markTracked(eventKey: string): void {
    const tracked = getTrackedEvents();
    tracked.add(eventKey);
    sessionStorage.setItem(TRACKED_KEY, JSON.stringify([...tracked]));
}

function isTracked(eventKey: string): boolean {
    return getTrackedEvents().has(eventKey);
}

export class TrackingUtil {
    /**
     * Check if current session is still valid (for API fetch caching)
     */
    static isSessionValid(): boolean {
        return getSession() !== null;
    }

    /**
     * Start or refresh a session
     */
    static ensureSession(): void {
        ensureSession();
    }

    static trackView(campaignId: string | null, shopId?: string): void {
        if (!campaignId) return;

        ensureSession();
        const eventKey = `view_${campaignId}`;
        if (isTracked(eventKey)) return;

        const shop_id = shopId || window.TS_STORE_DATA?.store_id || '73174876382';
        const apiUrl = window.TS_STORE_DATA?.api_url || 'https://ops.trustshop.io';

        fetch(`${apiUrl}/api/campaigns/${campaignId}/track/view?shop_id=${shop_id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            mode: 'cors'
        }).then(() => {
            markTracked(eventKey);
        }).catch(() => {});
    }

    static trackClick(campaignId: string | null, actionType: 'primary' | 'secondary' = 'primary', shopId?: string): void {
        if (!campaignId) return;

        ensureSession();
        const eventKey = `click_${actionType}_${campaignId}`;
        if (isTracked(eventKey)) return;

        const shop_id = shopId || window.TS_STORE_DATA?.store_id || '73174876382';
        const apiUrl = window.TS_STORE_DATA?.api_url || 'https://ops.trustshop.io';

        fetch(`${apiUrl}/api/campaigns/${campaignId}/track/click`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                shop_id: shop_id,
                action_type: actionType
            }),
            mode: 'cors'
        }).then(() => {
            markTracked(eventKey);
        }).catch(() => {});
    }
}
